// serviceFlags.js
export const SERVICE_FLAGS = [
  {
    name: "requiredContinuation",
    labelKey: "global:service.flags.continuation",
    defaultLabel: "Kontynuacja",
  },
  {
    name: "requiredItService",
    labelKey: "global:service.flags.itService",
    defaultLabel: "Usługa IT",
  },
  {
    name: "requiredReplacementDevice",
    labelKey: "global:service.flags.replacementDevice",
    defaultLabel: "Urządzenie zastępcze",
  },
  {
    name: "requiredInvoice",
    labelKey: "global:service.flags.invoice",
    defaultLabel: "Faktura",
  },
  {
    name: "requiredQuotation",
    labelKey: "global:service.flags.quotation",
    defaultLabel: "Wycena",
  },
  {
    name: "requiredClaim",
    labelKey: "global:service.flags.claim",
    defaultLabel: "Claim",
  },
  {
    name: "requiredExpertise",
    labelKey: "global:service.flags.expertise",
    defaultLabel: "Ekspertyzy",
  },
  {
    name: "unjustifiedService",
    labelKey: "global:service.flags.unjustified",
    defaultLabel: "Usługa nieuzasadniona",
  },
];
